import React from "react";
import "./FilterOffcanvas.css";
import { Offcanvas } from "react-bootstrap";

function FilterOffcanvas({
  show,
  handleClose,
  modelSearch,
  setModelSearch,
  category,
  selectedCategoryId,
  selectedSubCategory,
  setSelectedCategoryId,
  setSelectedSubCategory,
  setOnPageChange,
  navigate,
  location,
  staticSubCategories,
  subcategory,
}) {
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="start"
      className="mobile-filter-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>a
          Product Filters
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="filter-sidebar-card">
          <h5 className="sidebar-main-title">
            Filter By
          </h5>

          {/* Product Search */}
          <div className="filter-group mb-4">
            <label className="sidebar-label">
              Product
            </label>

            <div className="d-flex flex-column gap-2 mt-1">
              <input
                type="text"
                className="form-control model-search-input"
                placeholder="Enter Model No."
                value={modelSearch}
                onChange={(e) =>
                  setModelSearch(e.target.value)
                }
              />

              <button className="btn btn-filter-action d-flex align-items-center justify-content-center gap-2">
                <i className="bi bi-search"></i>
                FILTER
              </button>
            </div>
          </div>

          {/* Categories */}
          <div className="filter-group">
            <label className="sidebar-label mb-2">
              Categories
            </label>

            <ul className="sidebar-category-list">
              {category?.map((item) => {
                const isSelected =
                  String(selectedCategoryId) ===
                  String(item.id);

                return (
                  <li
                    key={item.id}
                    className="category-list-wrapper"
                  >
                    <div
                      className={`category-item d-flex justify-content-between align-items-center ${
                        isSelected ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedCategoryId(item.id);
                        setSelectedSubCategory(null);
                        setOnPageChange(1);

                        navigate(location.pathname, {
                          replace: true,
                          state: {},
                        });
                      }}
                    >
                      <span className="category-name-text">
                        {item.name}
                      </span>

                      <span className="category-count-badge">
                        ({item.product_count || 0})
                      </span>
                    </div>

                    {isSelected && (
                      <ul className="sidebar-subcategory-list animate-fade-down">
                        {subcategory?.map(
                          (sub) => (
                            <li
                              key={sub.id}
                              className={`subcategory-item ${
                                selectedSubCategory ===
                                sub.id
                                  ? "sub-active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();

                                setSelectedSubCategory(
                                  sub.id
                                );

                                setOnPageChange(1);
                              }}
                            >
                              <span className="bullet-dot">
                                •
                              </span>

                              {sub.name}
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default FilterOffcanvas;